<template lang="pug">
.city-background-image(:class="addHeader ? 'with-header':''")
  .city-background-image__header(v-if="addHeader")
    .city-background-image__header_content
      img.asu-logo(src="@/assets/img/asuparticipax2.png" alt="People")
      .city-background-image__title AsuParticipa para AsuCostera
      button(v-if="showGoToListButton" @click="$router.push({ name: 'listProject' })") Ir a la lista
      button(@click="logout()") Cerrar sesión
    LineMultiColorHeaderSeparator
  .city-background-image__content
    slot
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    addHeader: {
      type: Boolean,
      default: false
    },
    showGoToListButton: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapActions([ 'logout' ])
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/variables'

.city-background-image
  background: url('~@/assets/img/background/4000x2250-oscuro.jpg') no-repeat center center fixed
  background-size: cover
  min-height: 100vmin
  min-height: 100vh
  &__header
    position: fixed
    top: 0
    &_content
      display: flex
      align-items: center
      justify-content: space-around
      height: ($city-background-image-header-height - $line-multicolor-header-separator-height)
      img
        height: $city-background-image-header-height * .8
      button
        background-color: white
        border-radius: 2px
        border: 1px solid $color_3
        color: $color_3
        padding: $f5px $f10px
  &__title
    color: white
    font-size: $f35px
    font-weight: bold
  &.with-header &__content
    height: "calc(100vmin - %s)" % $city-background-image-header-height
    height: "calc(100vh - %s)" % $city-background-image-header-height
    top: $city-background-image-header-height
    position: relative
    overflow: auto

</style>
